import type { AxiosInstance } from 'axios';
import { createHttp } from '@/http/axios';
import { isServedByLiveApi } from '@/http/publicReadApi';

/** Court : l'échange précède la lecture de l'offre et ne doit pas la retarder. */
const EXCHANGE_TIMEOUT_MS = 3000;

let exchangeHttp: AxiosInstance | undefined;
const exchanges = new Map<string, Promise<void>>();

/**
 * live-api lit le nom, le téléphone et la ville du spectateur dans ce cookie : le token ne les porte pas.
 * Un échec ne bloque pas la lecture (ces variables restent vides) et la lecture suivante retente.
 */
export function ensureAttendeeProfileCookie(authorization: string): Promise<void> {
  const pending = exchanges.get(authorization);
  if (pending) return pending;
  // un refus du token ne doit ni rafraîchir la session ni vider le contexte du spectateur
  exchangeHttp ??= createHttp(undefined, EXCHANGE_TIMEOUT_MS, { recoverSession: false });
  const exchange = exchangeHttp
    .post('/public/webinars/attendee-profile-cookie', null, {
      headers: { Authorization: authorization },
    })
    .then(
      () => undefined,
      () => {
        exchanges.delete(authorization);
      },
    );
  exchanges.set(authorization, exchange);
  return exchange;
}

/**
 * Seules les offres servies par live-api ont besoin du cookie. Appelé dès l'arrivée sur la page : une
 * offre poussée en live est lue par tous les spectateurs à la même seconde, l'échange ne doit pas
 * tomber à ce moment-là sur welya-api.
 */
export function primeAttendeeProfileCookie(authorization: string): Promise<void> {
  return isServedByLiveApi({ authorization, canary: 'offer' })
    ? ensureAttendeeProfileCookie(authorization)
    : Promise.resolve();
}
